// extracted by mini-css-extract-plugin
module.exports = {"Main":"OnHandItemMetaData_Main__2nUaJ"};